import { Header } from "../ui/header";
export const ProductPageLoading = () => {
  return (
    <div className="min-h-screen w-full bg-white">
      <Header showBackButton={true} />
      <div className="pt-16 pb-24">
        <div className="animate-pulse">
          <div className="w-full h-[400px] bg-gray-200"></div>
          <div className="px-5 space-y-6 mt-6">
            <div className="space-y-4">
              <div className="h-8 bg-gray-200 rounded w-3/4"></div>
              <div className="h-6 bg-gray-200 rounded w-1/2"></div>
              <div className="h-4 bg-gray-200 rounded w-1/4"></div>
            </div>
            <div className="space-y-4">
              <div className="h-6 bg-gray-200 rounded w-1/3"></div>
              <div className="flex gap-3">
                {[...Array(4)].map((_, i) => (
                  <div
                    key={i}
                    className="w-12 h-12 bg-gray-200 rounded-full"
                  ></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
